import { mapActions, mapGetters } from "vuex";
import FileSaver from "file-saver";

export default {
  computed: {
    ...mapGetters({
      getFile: "drawer/getFile",
    }),
  },
  methods: {
    ...mapActions({
      download: "drawer/download",
    }),
    async downloadFile(document) {
      await this.download(document.documentId);
      let blob = this.getFile(document.documentId);
      FileSaver.saveAs(blob, document.fileName);
    },
  },
};
